import { Controller } from "@hotwired/stimulus"

// seq-list — manages the generative-loop "Then cycle through" sequence: add a row
// (clone the <template>) or remove one, up to `max`. Each row is its own seq-entry
// controller; removing one notifies the live preview so the entry drops out.
export default class extends Controller {
  static targets = ["rows", "template", "addButton"]
  static values = { max: Number }

  connect() {
    this.updateAddButton()
  }

  add() {
    if (this.count() >= this.maxValue) return
    this.rowsTarget.appendChild(this.templateTarget.content.cloneNode(true))
    this.updateAddButton()
  }

  remove(event) {
    const row = event.target.closest("[data-seq-list-target='row']")
    if (!row) return
    // blank + fire input so the live preview drops this entry, then remove the row.
    const encoded = row.querySelector("[data-seq-entry-target='encoded']")
    if (encoded) {
      encoded.value = ""
      encoded.dispatchEvent(new Event("input", { bubbles: true }))
    }
    row.remove()
    this.updateAddButton()
  }

  count() {
    return this.rowsTarget.querySelectorAll("[data-seq-list-target='row']").length
  }

  updateAddButton() {
    if (this.hasAddButtonTarget) this.addButtonTarget.hidden = this.count() >= this.maxValue
  }
}
